module.exports = __webpack_public_path__ + "static/media/patil_MjZK8A03TF.2d6d9c1a.jpg";